module.exports = __webpack_public_path__ + "img/flecha-arriba (1).246ec82a.png";